import axios from 'axios';
import { formatDateTime } from '../../utils/dates';

// Notifications SMS — data access + shared vocabulary. Mirrors Backend
// app/api/customer_sms.py and app/services/customer_sms_service.py.

export const API = '/api/customer-sms';

const authHeaders = () => ({ headers: { Authorization: `Bearer ${localStorage.getItem('access_token')}` } });

export const get = (path, params) => axios.get(`${API}${path}`, { ...authHeaders(), params });
export const put = (path, body) => axios.put(`${API}${path}`, body, authHeaders());
export const post = (path, body) => axios.post(`${API}${path}`, body, authHeaders());
export const del = (path) => axios.delete(`${API}${path}`, authHeaders());
// Multipart: axios sets the boundary itself.
export const postForm = (path, form) => axios.post(`${API}${path}`, form, authHeaders());

export const fail = (error, fallback) => {
    const detail = error?.response?.data?.detail;
    if (typeof detail === 'string') return detail;
    if (Array.isArray(detail) && detail[0]?.msg) return detail[0].msg;
    return fallback;
};

export const EVENTS = ['parcel_problem', 'parcel_moving_again', 'parcel_delivered'];

export const formatWhen = (value, lang) => (value ? formatDateTime(value, {}, lang === 'en' ? 'en-GB' : 'fr-FR') : '—');

// What the recipient reads: the template with the sample values (same rules
// as the backend's render(): unknown variables stay, an empty « ( ) » goes).
export const renderSms = (template, values) => {
    let text = template || '';
    ['tracking', 'carrier', 'order'].forEach((name) => {
        text = text.split(`{${name}}`).join(values?.[name] || '');
    });
    return text.replace(/\(\s*\)/g, '').replace(/\s+/g, ' ').trim();
};

// GSM-7 (160 chars, 153 per part) unless a character needs Unicode (70 / 67).
const GSM_BASIC = new Set(Array.from(
    '@£$¥èéùìòÇ\nØø\rÅåΔ_ΦΓΛΩΠΨΣΘΞÆæßÉ !"#¤%&\'()*+,-./0123456789:;<=>?¡ABCDEFGHIJKLMNOPQRSTUVWXYZÄÖÑÜ§¿abcdefghijklmnopqrstuvwxyzäöñüà'
));
const GSM_EXTENDED = new Set(Array.from('^{}\\[~]|€'));

export const smsLength = (text) => {
    let units = 0;
    for (const ch of Array.from(text || '')) {
        if (GSM_BASIC.has(ch)) units += 1;
        else if (GSM_EXTENDED.has(ch)) units += 2;
        else {
            const chars = Array.from(text).length;
            return { unicode: true, chars, parts: chars <= 70 ? 1 : Math.ceil(chars / 67) };
        }
    }
    return { unicode: false, chars: units, parts: units <= 160 ? 1 : Math.ceil(units / 153) };
};

export const formatBytes = (size) => {
    if (!size && size !== 0) return '';
    if (size < 1024 * 1024) return `${Math.max(1, Math.round(size / 1024))} Ko`;
    return `${(size / (1024 * 1024)).toFixed(1)} Mo`;
};
